import { MODEL_FILTER_TYPES } from 'dashboard409a/components/ModelsTable/ModelsTable.types';
import WorkboardModelsTable from '../WorkboardModelsTable/WorkboardModelsTable';

const WorkboardModels = () => <WorkboardModelsTable filterType={MODEL_FILTER_TYPES.ASSIGNED} />;

export default WorkboardModels;

